import { Delete, Edit, RemoveRedEye } from "@mui/icons-material";
import {
  Card,
  Chip,
  Icon,
  IconButton,
  Switch,
  Tooltip,
  Menu,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  CircularProgress,
  Grid,
  Pagination,
  Stack,
} from "@mui/material";
import AstrieskIcon from "components/AstrieskIcon";
import SkConfirm from "components/SkComfirm";
import SkLoading from "components/SkLoading";
import SkModal from "components/SkModal";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import { useMaterialUIController } from "context";
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { handleAlert } from "redux/festures/alertSlice";
import {
  deleteCategory,
  disableServiceCategory,
  getNullParentCategory,
  approveCategoryStatus,
  rejectCategoryStatus,
} from "redux/festures/categorySlice";
import PcatogeroyUpdate from "./PcatogeroyUpdate";
import SingleCategory from "./SingleCategory";
import MDInput from "components/MDInput";

const columns = {
  serviceCategories: [
    { Header: "S.No", accessor: "no" },
    { Header: "category details", accessor: "category details" },
    { Header: "Category Status", accessor: "categoryStatus" },
    { Header: "disable", accessor: "disable" },
    // { Header: "view", accessor: "view" },
    { Header: "Reason for Rejection", accessor: "reason" },
    { Header: "action", accessor: "action" },
    // { Header: "delete", accessor: "delete" },
  ],
};

const Category = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const adminId = localStorage.getItem("admin_id");

  const { Loading, serviceCategory } = useSelector((state) => state.isCategory);

  const [formOpen, setFormOpen] = useState(false);
  const [viewOpen, setViewOpen] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [confirmState, setConfirmState] = useState({ open: false, item: null });

  const [statusAnchor, setStatusAnchor] = useState(null);
  const [selectedStatusCategory, setSelectedStatusCategory] = useState(null);
  const [rejectModalOpen, setRejectModalOpen] = useState(false);
  const [rejectReason, setRejectReason] = useState("");

  const [page, setPage] = useState(1);
  const itemsPerPage = 10;
  const totalPages = Math.ceil((serviceCategory?.length || 0) / itemsPerPage) || 1;

  useEffect(() => {
    if (page > totalPages && totalPages > 0) {
      setPage(1);
    }
  }, [totalPages, page]);

  const handleApproveStatus = async () => {
    setStatusAnchor(null);
    if (!selectedStatusCategory) return;
    const response = await dispatch(
      approveCategoryStatus({ categoryId: selectedStatusCategory._id, adminId })
    );
    dispatch(
      handleAlert({
        isOpen: true,
        type: response.payload?.success ? "success" : "error",
        msg: response.payload?.message,
      })
    );
    if (response.payload?.success) refreshCategories();
  };

  const handleOpenRejectModal = () => {
    setStatusAnchor(null);
    setRejectReason("");
    setRejectModalOpen(true);
  };

  const handleRejectSubmit = async () => {
    if (!rejectReason.trim()) {
      dispatch(handleAlert({ isOpen: true, type: "error", msg: "Reject reason is required" }));
      return;
    }
    const response = await dispatch(
      rejectCategoryStatus({
        categoryId: selectedStatusCategory._id,
        adminId,
        reason: rejectReason,
      })
    );
    dispatch(
      handleAlert({
        isOpen: true,
        type: response.payload?.success ? "success" : "error",
        msg: response.payload?.message,
      })
    );
    if (response.payload?.success) {
      setRejectModalOpen(false);
      refreshCategories();
    }
  };

  const refreshCategories = () => {
    if (adminId) dispatch(getNullParentCategory(adminId));
  };

  useEffect(() => {
    refreshCategories();
  }, [adminId, dispatch]);

  const handleDisableToggle = async (categoryId) => {
    const response = await dispatch(
      disableServiceCategory({
        url: `${process.env.REACT_APP_APII}/toggleCategoryStatus/${categoryId}/${adminId}`,
      })
    );

    dispatch(
      handleAlert({
        isOpen: true,
        type: response?.payload?.success ? "success" : "error",
        msg: response?.payload?.message,
      })
    );

    if (response?.payload?.success) refreshCategories();
  };

  const paginatedCategory = useMemo(() => {
    if (!serviceCategory?.length) return [];
    const startIndex = (page - 1) * itemsPerPage;
    return serviceCategory.slice(startIndex, startIndex + itemsPerPage);
  }, [serviceCategory, page]);

  const rowsData = useMemo(() => {
    if (!paginatedCategory?.length) return [];

    return paginatedCategory.map((value, index) => ({
      no: (
        <MDTypography sx={{ fontSize: 12, fontWeight: "medium" }} variant="text">
          {(page - 1) * itemsPerPage + index + 1}
        </MDTypography>
      ),
      "category details": (
        <MDBox display="flex" alignItems="center" gap={1.5}>
          <MDBox sx={{ width: 44, height: 44 }}>
            <img
              src={`${process.env.REACT_APP_URI}${value?.icon}`}
              alt={value?.name || "category"}
              onError={(e) => {
                e.onerror = null;
                e.target.src = require("../../assets/images/bg-profile.png");
              }}
              style={{ width: "100%", height: "100%", borderRadius: "50%", objectFit: "cover" }}
            />
          </MDBox>
          <MDBox>
            <MDTypography variant="button" fontWeight="medium" display="block">
              {value?.name || "N/A"}
            </MDTypography>
            <MDTypography variant="caption" display="block">
              ID: {value?._id || "N/A"}
            </MDTypography>
            <MDTypography variant="caption" display="block">
              Experience: {value?.workExperience || 0} yrs
            </MDTypography>
          </MDBox>
        </MDBox>
      ),
      categoryStatus: (
        <MDBox
          onClick={(e) => {
            setStatusAnchor(e.currentTarget);
            setSelectedStatusCategory(value);
          }}
          sx={{ cursor: "pointer", display: "inline-block" }}
        >
          <Tooltip title="Update Status">
            <Chip
              label={value.categoryStatus || "approved"}
              color={
                value.categoryStatus === "rejected"
                  ? "error"
                  : value.categoryStatus === "pending"
                    ? "warning"
                    : "success"
              }
              size="small"
              sx={{ cursor: "pointer" }}
            />
          </Tooltip>
        </MDBox>
      ),
      disable: (
        <Tooltip title={value?.disable ? "Move to active" : "Move to inactive"}>
          <Switch
            checked={Boolean(value?.disable)}
            color="info"
            onChange={() => handleDisableToggle(value?._id)}
          />
        </Tooltip>
      ),
      // view: (
      //   <IconButton
      //     aria-label="view-service-category"
      //     onClick={() => {
      //       setSelectedCategory(value);
      //       setViewOpen(true);
      //     }}
      //   >
      //     <RemoveRedEye
      //       sx={({ palette: { dark, info } }) => ({
      //         color: darkMode ? info.main : dark.main,
      //       })}
      //     />
      //   </IconButton>
      // ),
      reason: (
        <MDTypography sx={{ fontSize: 12, fontWeight: "medium" }} variant="text">
          {value?.rejectionReason || "-"}
        </MDTypography>
      ),
      action: (
        <MDBox display="flex" alignItems="center">
          <Tooltip title="View sub categories">
            <IconButton
              aria-label="view-sub-categories"
              onClick={() =>
                navigate(`/subcategory-view/${value?._id}`, {
                  state: { parentCategory: value },
                })
              }
            >
              <RemoveRedEye
                sx={({ palette: { dark, info } }) => ({
                  color: darkMode ? info.main : dark.main,
                })}
              />
            </IconButton>
          </Tooltip>
          <Tooltip title="Edit parent category">
            <IconButton
              aria-label="edit-service-category"
              onClick={() => {
                setSelectedCategory(value);
                setIsUpdate(true);
                setFormOpen(true);
              }}
            >
              <Edit
                sx={({ palette: { dark, info } }) => ({
                  color: darkMode ? info.main : dark.main,
                })}
              />
            </IconButton>
          </Tooltip>
        </MDBox>
      ),
      // delete: (
      //   <Tooltip title="Delete parent category">
      //     <IconButton
      //       aria-label="delete-service-category"
      //       onClick={() => setConfirmState({ open: true, item: value })}
      //     >
      //       <Delete
      //         sx={({ palette: { dark, error } }) => ({
      //           color: darkMode ? error.main : dark.main,
      //         })}
      //       />
      //     </IconButton>
      //   </Tooltip>
      // ),
    }));
  }, [darkMode, navigate, paginatedCategory, page]);

  return (
    <>
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox py={3}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: 2,
                flexWrap: "wrap",
              }}
            >
              <MDBox>
                <MDTypography variant="h6" color="white">
                  Service Category Table
                </MDTypography>
                <MDTypography variant="button" color="white" fontWeight="regular">
                  Manage parent service categories and drill into sub categories
                </MDTypography>
              </MDBox>

              <MDButton
                variant="gradient"
                color="dark"
                disabled={Loading}
                sx={({ palette: { dark, white } }) => ({
                  color: white.main,
                  backgroundColor: dark.main,
                  "&:hover": {
                    color: white.main,
                    backgroundColor: dark.main,
                  },
                })}
                onClick={() => {
                  setSelectedCategory(null);
                  setIsUpdate(false);
                  setFormOpen(true);
                }}
              >
                <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                &nbsp; Create Parent Category
              </MDButton>
            </MDBox>

            <MDBox pt={3}>
              {Loading ? (
                <SkLoading />
              ) : rowsData.length ? (
                <>
                  <DataTable
                    table={{
                      columns: columns.serviceCategories,
                      rows: rowsData,
                    }}
                    isSorted={false}
                    entriesPerPage={false}
                    showTotalEntries={false}
                    isPages={rowsData.length}
                    noEndBorder
                    canSearch={false}
                    pagination={false}
                    isPagination={false}
                  />
                  {totalPages > 1 && (
                    <MDBox
                      sx={{
                        mt: 4,
                        mb: 2,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Stack spacing={2} direction="row">
                        <Pagination
                          sx={({ palette: { dark, white, info } }) => ({
                            "& .MuiPaginationItem-root": {
                              color: darkMode ? white.main : dark.main,
                            },
                            "& .MuiPaginationItem-root.Mui-selected": {
                              backgroundColor: `${info.main} !important`,
                              color: `${white.main} !important`,
                            },
                          })}
                          color="info"
                          variant="outlined"
                          shape="rounded"
                          count={totalPages}
                          page={page}
                          onChange={(e, value) => setPage(value)}
                        />
                      </Stack>
                    </MDBox>
                  )}
                </>
              ) : (
                <MDTypography variant="h6" fontWeight="medium" align="center" py={4}>
                  Parent service categories not found.
                </MDTypography>
              )}
            </MDBox>
          </Card>
        </MDBox>
        <Footer />
      </DashboardLayout>

      <SkModal
        show={viewOpen}
        unShow={setViewOpen}
        width={{ sx: "100%", md: "70%", xl: "70%", sm: "100%" }}
        height={"80%"}
        padding={3}
        overflowY={true}
      >
        <SingleCategory viewData={selectedCategory} />
      </SkModal>

      <SkModal
        show={formOpen}
        unShow={setFormOpen}
        width={{ sx: "100%", md: "70%", xl: "70%", sm: "100%" }}
        height={"80%"}
        padding={3}
        overflowY={true}
      >
        <PcatogeroyUpdate
          viewData={selectedCategory}
          isPUpdates={isUpdate}
          setIsOpenUpdate={setFormOpen}
          onSuccess={refreshCategories}
        />
      </SkModal>

      <SkConfirm
        dialogTitle={"Delete"}
        dialogContent={"Are you sure you want to delete this parent service category?"}
        open={confirmState}
        setOpen={setConfirmState}
        dialogAction={
          <MDBox
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: 3,
              px: 3,
            }}
          >
            <MDButton
              variant="gradient"
              color="info"
              sx={{ width: "50%" }}
              onClick={() => setConfirmState({ open: false, item: null })}
            >
              Cancel
            </MDButton>
            <MDButton
              variant="gradient"
              sx={{ width: "50%" }}
              color="error"
              onClick={async () => {
                const response = await dispatch(
                  deleteCategory({
                    url: `${process.env.REACT_APP_APII}/deleteCategory/${confirmState?.item?._id}/${adminId}`,
                  })
                );

                dispatch(
                  handleAlert({
                    isOpen: true,
                    type: response?.payload?.success ? "success" : "error",
                    msg: response?.payload?.message,
                  })
                );

                if (response?.payload?.success) refreshCategories();
                setConfirmState({ open: false, item: null });
              }}
            >
              Yes
            </MDButton>
          </MDBox>
        }
      />

      <Menu
        anchorEl={statusAnchor}
        open={Boolean(statusAnchor)}
        onClose={() => setStatusAnchor(null)}
      >
        <MenuItem onClick={handleApproveStatus}>Approve</MenuItem>
        <MenuItem onClick={handleOpenRejectModal}>Reject</MenuItem>
      </Menu>

      <SkModal
        show={rejectModalOpen}
        unShow={setRejectModalOpen}
        width={{ sx: "100%", md: "50%" }}
        height={"auto"}
        padding={3}
        overflowY={true}
      >
        <Grid item xs={12}>
          <MDTypography variant="h6">
            Category Rejection Reason <AstrieskIcon />
          </MDTypography>
          <MDInput
            fullWidth
            name="Reason for Rejection"
            value={rejectReason}
            onChange={(e) => setRejectReason(e.target.value)}
            placeholder="Enter reason for rejection"
            multiline
            rows={4}
            sx={{ mt: 1 }}
          />
        </Grid>
        <MDBox
          mt={3}
          sx={{
            display: "flex",
            justifyContent: { xs: "stretch", md: "flex-end" },
            gap: 1.5,
            flexDirection: { xs: "column", md: "row" },
          }}
        >
          <MDButton variant="outlined" color="secondary" onClick={() => setRejectModalOpen(false)}>
            Cancel
          </MDButton>
          <MDButton onClick={handleRejectSubmit} color="info" variant="gradient">
            Submit
          </MDButton>
        </MDBox>
      </SkModal>
    </>
  );
};

export default Category;
